// extracted by mini-css-extract-plugin
module.exports = {"surveysTabPane":"surveysTabPane_surveysTabPane__2MY3A","tab":"surveysTabPane_tab__3ugYK"};